module.exports = __webpack_public_path__ + "img/formula11.8a557075.png";